'use client';
import React from 'react';
import type { ScenarioData } from '../getScenarioData';

const Context = React.createContext<
  | {
      data: ScenarioData;
      scenarioId: string;
    }
  | undefined
>(undefined);

export const ScenarioDataContextProvider: React.FC<
  React.PropsWithChildren & {
    scenarioId: string;
    data: ScenarioData;
  }
> = ({ children, data, scenarioId }) => (
  <Context.Provider
    value={{
      data,
      scenarioId,
    }}
  >
    {children}
  </Context.Provider>
);

export function useUserCreateScenario() {
  const context = React.useContext(Context);

  if (!context) {
    throw new Error(
      'useUserCreateScenario must be used within a ScenarioProvider'
    );
  }

  return context;
}
